import { FunctionComponent, useState } from 'react'
import styles from '../export.module.scss'
import { BrowserUpdated } from '@mui/icons-material'
import { useTranslation } from 'react-i18next'
import { ExportDataType } from '@/types/Export'
import { Daycare } from '@/types/Daycare'
import ExportDialog from '../exportDialog.tsx'

interface ExportRegularSlotsProps {
    daycares: Daycare[]
    isRpeOrLaep: boolean
    minDate: string
}

const ExportRegularSlots: FunctionComponent<ExportRegularSlotsProps> = ({
    daycares,
    isRpeOrLaep,
    minDate
}: ExportRegularSlotsProps) => {
    const { t } = useTranslation()

    const [isDialogOpen, setIsDialogOpen] = useState<boolean>(false)

    return (
        <>
            <a className={styles.Case} onClick={(): void => setIsDialogOpen(true)}>
                <p className={styles.CaseTitle}>{isRpeOrLaep ? t('regularsGroups') : t('regularSlots')}</p>
                <BrowserUpdated className={styles.CaseIcon} />
            </a>
            {isDialogOpen && (
                <ExportDialog
                    type={ExportDataType.RegularSlots}
                    open={isDialogOpen}
                    handleClose={(): void => setIsDialogOpen(false)}
                    daycares={daycares}
                    minDate={minDate}
                    isRpeOrLaep={isRpeOrLaep}
                />
            )}
        </>
    )
}

export default ExportRegularSlots
